// extracted by mini-css-extract-plugin
export default {"button":"VGSr3","hide-pointer-event":"hXON0"};